import { useState } from "react";
import axios from "axios";
import { CustomButtonProps } from "../models/PropsInterface";
import t from "../locales/translation";
import Swal from "sweetalert2";
import {
  logBoostListingBundle,
  logOrderProductsClickAddCart,
} from "../logging/helpers/commonLoggingFunctions";
import { updateScreenHistory } from "../logging/helpers/updateScreenHistory";
import { ActionDimensions } from "../logging/dimensions/ActionDimensions";
import { DEFAULT_VALUE } from "../logging/types/LoggingTypes";
import "../cssStyles/CustomButton.css";

// import Modal from "../UI/Modal/Modal";

const CustomButton = (props: CustomButtonProps) => {
  const getUrlBasedOnCountry = (country: string): string => {
    const url = `https://XX.${props.domain}.com`;
    return url.replace("XX", country);
  };

  const [isDisabled, setIsDisabled] = useState<boolean>(false);
  // const [isOpen, setIsOpen] = useState<boolean>(false);

  const url = getUrlBasedOnCountry(props.countryAbbreviation);

  const textStyle = {
    backgroundColor: "#f39c12",
    fontWeight: "bold",
    fontSize: "16px",
  };

  const purchase = async () => {
    return axios.post(
      `${props.api}/checkout/create-cart`,
      {
        Payment: {
          productAssignId: props.productAssignId,
          modelId: props.modelId,
          absoluteUrl: props.referral_url ?? window.location.href,
          posSource: props.pos_source,
        },
      },
      {
        headers: {
          source: props.source,
          // country: props.countryAbbreviation,
          country: localStorage.getItem("countryCode"),
          [`enforce-language`]: props.language,
          [`Authorization`]: "Bearer " + props.token,
        },
      }
    );
  };

  const consumeBundle = async () => {
    return axios.post(
      `${props.api}/bundle-user/purchase`,
      {
        BundleUser: {
          id: props.bundleId,
          postId: props.modelId,
        },
      },
      {
        headers: {
          source: props.source,
          country: props.countryAbbreviation,
          [`enforce-language`]: props.language,
          [`Authorization`]: "Bearer " + props.token,
        },
      }
    );
  };

  const purchaseAction = () => {
    //logging
    logOrderProductsClickAddCart();
    //
    purchase().then((response) => {
      if (response.status === 201) {
        setIsDisabled(true);
        return (window.top.location.href = response.data.redirect);
      }
    });
  };

  const checkout = () => {
    if (!props.isBundle) {
      if (!props.showConfirmation) {
        return purchase().then((response) => {
          if (response.status === 201) {
            setIsDisabled(true);
            return (window.top.location.href =
              response.data.redirect +
              `&SessionFunnelSource=${
                ActionDimensions.getInstance().sessionFunnelSource
              }`);
          }
        });
      }
      return Swal.fire({
        icon: "warning",
        iconColor: "#0d6efd",
        html: `<div class="vas-pe-10 vas-ps-10 vas-fw-bolder">${props.confirmationText}</div>`,
        buttonsStyling: false,
        showCancelButton: true,
        cancelButtonText: t.rejectText,
        showLoaderOnConfirm: true,
        confirmButtonText: t.approveText,
        reverseButtons: props.language != "en",
        customClass: {
          confirmButton:
            "vas-btn vas-btn-lg vas-btn-primary vas-ps-5 vas-pe-5 vas-m-1 ",
          cancelButton:
            "vas-btn vas-btn-lg vas-btn-danger vas-ps-5 vas-pe-5 vas-m-1",
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          purchaseAction();
        }
      });
    } else {
      return Swal.fire({
        icon: "warning",
        iconColor: "#0d6efd",
        html: `<div class="vas-pe-10 vas-ps-10 vas-fw-bolder">${t.useBundleConfirmation}</div>`,
        buttonsStyling: false,
        showCancelButton: true,
        cancelButtonText: t.rejectText,
        showLoaderOnConfirm: true,
        confirmButtonText: t.approveText,
        reverseButtons: props.language != "en",
        customClass: {
          confirmButton:
            "vas-btn vas-btn-lg vas-btn-primary vas-ps-3 vas-pe-3 vas-m-1 ",
          cancelButton:
            "vas-btn vas-btn-lg vas-btn-danger vas-ps-3 vas-pe-3 vas-m-1",
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        if (result.isConfirmed) {
          ActionDimensions.getInstance().sessionFunnelSource = DEFAULT_VALUE;
          logBoostListingBundle(props.modelId);
          consumeBundle().then((response) => {
            if (response.status === 200) {
              setIsDisabled(true);
              props.setIsSuccessProcess(true);

              // props.setIsSuccessProcess(true)
              // parent.location.reload();
              // return window.top.location.href = `${url}/search/${props.modelId}`
            }
          });
        }
      });
    }
  };

  return (
    <>
      <div onClick={checkout} className={`custom_button__max_width`}>
        <button
          disabled={isDisabled}
          style={textStyle}
          className={`vas ${
            props.selectedId === props.productAssignId
              ? ""
              : "custom_button__disabled"
          } custom_button__customShadow custom_button__max_width custom_button__custom_font_size`}
        >
          {props.isBundle ? t.useBundle : t.buyNow}
        </button>
      </div>
      {/*{isOpen && <Modal setIsOpen={setIsOpen} approveAction={!props.isBundle ? purchaseAction : useBundleAction}*/}
      {/*                  confirmationMessage={props.isBundle ? t.useBundleConfirmation : props.showConfirmation && props.confirmationText}*/}

      {/*/>}*/}
    </>
  );
};

export default CustomButton;
